// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Montserrat/static/Montserrat-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Montserrat/static/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
html {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  color: #161a1d;
}

@font-face {
  font-family: "big";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "paragraph";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
h1 {
  font-size: 40px;
  margin: 24px 0px;
  font-family: "big";
}

h2,
h3 {
  font-size: 32px;
  margin: 24px 0px;
  font-family: "big";
}

h4,
p,
a,
button,
label,
input {
  font-size: 22px;
  font-family: "paragraph";
  line-height: 1.6em;
}

button {
  border: 4px solid #941b0c;
  padding: 16px 24px;
  margin: 16px;
  background-color: white;
}
button:hover {
  cursor: pointer;
  background-color: #941b0c;
  color: white;
}

.thick-arrow {
  position: relative;
  width: 200px;
  height: 200px;
}
.thick-arrow .main-arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-left: 40px solid transparent;
  border-right: 40px solid transparent;
  border-bottom: 80px solid #f6aa1c;
  transform: translate(-50%, -46%);
  z-index: 2;
}
.thick-arrow .stroke-arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-left: 52px solid transparent;
  border-right: 52px solid transparent;
  border-bottom: 104px solid #161a1d;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.down-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.down-btn p {
  background-color: white;
  border-radius: 40px;
  padding: 16px;
}
.down-btn .arrow {
  position: relative;
  height: 80px;
  width: 80px;
}
.down-btn .arrow .straight,
.down-btn .arrow .left,
.down-btn .arrow .right {
  position: absolute;
  display: inline-block;
  height: 4px;
  background-color: white;
}
.down-btn .arrow .straight {
  transform: rotate(90deg);
  top: 35px;
  left: 20px;
  width: 40px;
}
.down-btn .arrow .left {
  transform: rotate(45deg);
  top: 48px;
  left: 20px;
  width: 24px;
}
.down-btn .arrow .right {
  transform: rotate(-45deg);
  top: 48px;
  right: 20px;
  width: 24px;
}
.down-btn:hover {
  cursor: pointer;
  font-weight: bold;
}

.navbar {
  position: fixed;
  width: 100vw;
  z-index: 100;
}
.navbar .container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.navbar .container .opacity-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.6;
}
.navbar .container .logo {
  font-size: 24px;
  text-decoration: none;
  color: #161a1d;
  z-index: 100;
  margin-left: 24px;
  position: relative;
}
.navbar .container .logo img {
  width: auto;
  height: 50px;
}
.navbar .container .burger {
  width: 50vw;
  z-index: 100;
}

@media screen and (max-width: 980px) {
  .navbar {
    width: 0px;
  }
  .navbar .logo {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/components/navbar/navbar.scss"],"names":[],"mappings":"AAUA;;EAEE,UAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAfW;ACMb;;ADYA;EACE,kBAAA;EACA,4CAAA;ACTF;ADYA;EACE,wBAAA;EACA,4CAAA;ACVF;ADaA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;ACXF;;ADcA;;EAEE,eAAA;EACA,gBAAA;EACA,kBAAA;ACXF;;ADcA;;;;;;EAME,eAAA;EACA,wBAAA;EACA,kBAAA;ACXF;;ADcA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAzDY;AC8Cd;ADaE;EACE,eAAA;EACA,yBA3DY;EA4DZ,YA9DU;ACmDd;;ADeA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;ACZF;ADcE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;EACA,UAAA;ACZJ;ADeE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,kCAAA;EACA,gCAAA;EACA,UAAA;ACbJ;;ADiBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;ACdF;ADgBE;EACE,uBAAA;EACA,mBAnGK;EAoGL,aAAA;ACdJ;ADiBE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;ACfJ;ADiBI;;;EAGE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,uBAAA;ACfN;ADkBI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AChBN;ADmBI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ACjBN;ADoBI;EACE,yBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AClBN;ADsBE;EACE,eAAA;EACA,iBAAA;ACpBJ;;AA/HA;EACE,eAAA;EACA,YAAA;EACA,YAAA;AAkIF;AAhIE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAkIJ;AAhII;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBDtBQ;ECuBR,YAAA;AAkIN;AA/HI;EACE,eAAA;EACA,qBAAA;EACA,cD5BO;EC6BP,YAAA;EACA,iBAAA;EACA,kBAAA;AAiIN;AA/HM;EACE,WAAA;EACA,YAAA;AAiIR;AA7HI;EACE,WAAA;EACA,YAAA;AA+HN;;AA1HA;EACE;IACE,UAAA;EA6HF;EA3HE;IACE,aAAA;EA6HJ;AACF","sourcesContent":["$light-color: white;\n$dark-color: #161a1d;\n$primary-color: #941b0c;\n$secondary-color: #f6aa1c;\n$third-color: #f5f3f4;\n\n$mobile-width: 980px;\n\n$radius: 40px;\n\n*,\nhtml {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  color: $dark-color;\n}\n\n@font-face {\n  font-family: \"big\";\n  src: url(\"../assets/fonts/Montserrat/static/Montserrat-Black.ttf\");\n}\n\n@font-face {\n  font-family: \"paragraph\";\n  src: url(\"../assets/fonts/Montserrat/static/Montserrat-Regular.ttf\");\n}\n\nh1 {\n  font-size: 40px;\n  margin: 24px 0px;\n  font-family: \"big\";\n}\n\nh2,\nh3 {\n  font-size: 32px;\n  margin: 24px 0px;\n  font-family: \"big\";\n}\n\nh4,\np,\na,\nbutton,\nlabel,\ninput {\n  font-size: 22px;\n  font-family: \"paragraph\";\n  line-height: 1.6em;\n}\n\nbutton {\n  border: 4px solid $primary-color;\n  padding: 16px 24px;\n  margin: 16px;\n  background-color: $light-color;\n\n  &:hover {\n    cursor: pointer;\n    background-color: $primary-color;\n    color: $light-color;\n  }\n}\n\n.thick-arrow {\n  position: relative;\n  width: 200px;\n  height: 200px;\n\n  .main-arrow {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    border-left: 40px solid transparent;\n    border-right: 40px solid transparent;\n    border-bottom: 80px solid $secondary-color;\n    transform: translate(-50%, -46%);\n    z-index: 2;\n  }\n\n  .stroke-arrow {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    border-left: 52px solid transparent;\n    border-right: 52px solid transparent;\n    border-bottom: 104px solid $dark-color;\n    transform: translate(-50%, -50%);\n    z-index: 1;\n  }\n}\n\n.down-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n\n  p {\n    background-color: white;\n    border-radius: $radius;\n    padding: 16px;\n  }\n\n  .arrow {\n    position: relative;\n    height: 80px;\n    width: 80px;\n\n    .straight,\n    .left,\n    .right {\n      position: absolute;\n      display: inline-block;\n      height: 4px;\n      background-color: white;\n    }\n\n    .straight {\n      transform: rotate(90deg);\n      top: 35px;\n      left: 20px;\n      width: 40px;\n    }\n\n    .left {\n      transform: rotate(45deg);\n      top: 48px;\n      left: 20px;\n      width: 24px;\n    }\n\n    .right {\n      transform: rotate(-45deg);\n      top: 48px;\n      right: 20px;\n      width: 24px;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n    font-weight: bold;\n  }\n}\n","@import \"../../styles/main.scss\";\n\n.navbar {\n  position: fixed;\n  width: 100vw;\n  z-index: 100;\n\n  .container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    .opacity-bg {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-color: $light-color;\n      opacity: 0.6;\n    }\n\n    .logo {\n      font-size: 24px;\n      text-decoration: none;\n      color: $dark-color;\n      z-index: 100;\n      margin-left: 24px;\n      position: relative;\n\n      img {\n        width: auto;\n        height: 50px;\n      }\n    }\n\n    .burger {\n      width: 50vw;\n      z-index: 100;\n    }\n  }\n}\n\n@media screen and (max-width: $mobile-width) {\n  .navbar {\n    width: 0px;\n\n    .logo {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
